import {infoMessage} from 'interactors/messageBus/create';
import {Emitter} from 'interactors/messageBus/Emitter';

type Dependencies = {
  emitter?: Emitter;
};

export function started(di: Dependencies = {}): void {
  const {emitter = Emitter} = di;
  emitter.emit(infoMessage('app-started'));
}
